import apiClient from "@/lib/api-client"
import type {
  Blog,
  BlogCreateRequest,
  BlogUpdateRequest,
  PaginatedResponse,
} from "@/types/api"

const buildQueryString = (params?: Record<string, any>): string => {
  if (!params) return ""
  const query = new URLSearchParams(params as any).toString()
  return query ? `?${query}` : ""
}

export const blogService = {
  // Blogs
  getBlogs: async (params?: {
    limit?: number
    offset?: number
    theme_slug?: string
  }): Promise<PaginatedResponse<Blog>> => {
    return apiClient.get<PaginatedResponse<Blog>>(
      `/course/blogs/${buildQueryString(params)}`
    )
  },

  getBlog: async (slug: string): Promise<Blog> => {
    return apiClient.get<Blog>(`/course/blogs/${slug}/`)
  },

  createBlog: async (data: BlogCreateRequest): Promise<Blog> => {
    return apiClient.post<Blog>("/course/blogs/", data)
  },

  updateBlog: async (slug: string, data: BlogUpdateRequest): Promise<Blog> => {
    return apiClient.patch<Blog>(`/course/blogs/${slug}/`, data)
  },

  deleteBlog: async (slug: string): Promise<void> => {
    await apiClient.delete(`/course/blogs/${slug}/`)
  },
}
